import React from 'react';
import IconButtonStyled from './IconButton.styled';
import Icon from '@/components/icon/Icon';
import { IconButtonProps, IconButtonTheme } from './IconButton.types';
import Tooltip from '@/components/tooltip/Tooltip';

const IconButton = (props: IconButtonProps) => {
  const {
    action,
    theme = IconButtonTheme.Primary,
    icon,
    srText,
    iconColor,
    tooltipText,
    ...rest
  } = props || {};
  return (
    <IconButtonStyled
      data-variant={theme}
      type="button"
      onClick={e => action(e)}
      {...rest}
    >
      <span className="focus-ring" />
      <Icon icon={icon} color={iconColor} />
      <span className="sr-only">{srText}</span>
      {tooltipText && (
        <Tooltip className="icon-button__tooltip" text={tooltipText} />
      )}
    </IconButtonStyled>
  );
};

export default IconButton;
